import { render } from "./App.vue.js?vue&type=template&id=d53cdc1e!=!../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./App.vue?vue&type=template&id=d53cdc1e"
import script from "./App.vue.js?vue&type=script&lang=js!=!../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./App.vue?vue&type=script&lang=js"
export * from "./App.vue.js?vue&type=script&lang=js!=!../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./App.vue?vue&type=script&lang=js"

import "./App.vue.scss?vue&type=style&index=0&id=d53cdc1e&lang=scss!=!../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./App.vue?vue&type=style&index=0&id=d53cdc1e&lang=scss"

import exportComponent from "../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__